import { useState, useRef, useEffect, useMemo } from "react";

import moment from "moment-timezone";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import Grid from "@mui/material/Grid";
//Backend access
import { getLiveviewHistoryImages } from 'services/api/bks';
import PropTypes from "prop-types";

import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { PacmanLoader } from "react-spinners";
import LiveviewFeed from "components/Timelines/LiveviewTimeline/Feed";
import LiveviewSelects from "components/Charts/Selectors/Liveview";

import bksAPI from 'services/api/bks';
import { useQuery } from "@tanstack/react-query";

// Images
function LiveviewTimeline({ uuid, device, deviceLayout, isPerspectiveLiveview, directionTrigger }) {

  const [endTime, setEndTime] = useState(moment().unix());
  const [startTime, setStartTime] = useState(moment().subtract(2, 'day').unix());
  const [currentTime, setCurrentTime] = useState(moment().unix());
  const [liveviewData, setLiveviewData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  bksAPI.loadToken(useAuth0());

  const currentLiveview = useQuery({
    queryKey: ['getLiveView', uuid],
    queryFn: async () => {
      return await bksAPI.getLiveView(uuid);
    }
  });

  useEffect(() => {
    async function getHistory() {
      // console.log(startTime, endTime);

      var data = await getLiveviewHistoryImages(uuid, startTime, endTime);
      // console.log(data);
      setLiveviewData(data);
      setIsLoading(false);
    }
    if (!isNaN(startTime) && !isNaN(endTime)) {
      getHistory();
    }
  }, [startTime, endTime]);


  if (currentLiveview.isLoading) {
    return "Loading...";
  }

  if (currentLiveview.error) {
    return "Error! " + currentLiveview.error.message;
  }

  const blob = new Blob([currentLiveview.data]);
  const current_liveview_url = URL.createObjectURL(blob);

  return (
    <LiveviewFeed {...{
      uuid, currentTime, setCurrentTime, startTime, setStartTime, endTime, setEndTime,
      liveviewData, isLoading, current_liveview_url, device, deviceLayout, isPerspectiveLiveview,
      directionTrigger
    }} />
  );
}

// Typechecking props for the LiveviewTimeline
LiveviewTimeline.propTypes = {
  uuid: PropTypes.string,
  device: PropTypes.object,
  deviceLayout: PropTypes.string,
  isPerspectiveLiveview: PropTypes.bool,
  directionTrigger: PropTypes.object
};


export default LiveviewTimeline;